import React from 'react'

interface SectionHeaderProps {
  title: string
  children: React.ReactNode
}
export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, children }) => (
  <div>
    <h2 className='review-collection-heading'>{title}</h2>
    {children}
  </div>
)
